/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

/**
 * Response data for the liveness check endpoint. This provides a simple indication of whether the Teral API service is running and able to process requests. Monitoring systems can use this endpoint to track service availability and trigger alerts if the service becomes unhealthy.
 */
export type V1LivenessResponseData = {
  /**
   * Status message indicating the health of the service. A value of 'OK' indicates that the service is functioning properly and ready to accept requests. Any other value indicates a potential issue with the service health.
   */
  message: string;
};

/** @internal */
export const V1LivenessResponseData$inboundSchema: z.ZodType<
  V1LivenessResponseData,
  z.ZodTypeDef,
  unknown
> = z.object({
  message: z.string(),
});

export function v1LivenessResponseDataFromJSON(
  jsonString: string,
): SafeParseResult<V1LivenessResponseData, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => V1LivenessResponseData$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'V1LivenessResponseData' from JSON`,
  );
}
